import React, { forwardRef, useImperativeHandle } from 'react';

const ItemSelector = forwardRef(({ items, selectedDoor, onSelect, disabled = false }, ref) => {
  useImperativeHandle(ref, () => ({
    setSelectedItem: (itemName) => {
      const item = items.find((i) => i.name === itemName);
      if (item) {
        onSelect(item);
        //console.log("Selected Item:", item.name);
      } else {
        //console.warn(`Item with name "${itemName}" not found.`);
      }
    },
  }));

  const handleSelect = (item) => {
    onSelect(item);
    console.log("Selected Item:", item.name);
  };

  return (
    <div className="item-selector-container">
      <div className="item-selector">
        {items.map((item) => (
          <img
            key={item.id}
            src={item.imageUrl}
            alt={item.name}
            className={`item-image ${selectedDoor && selectedDoor.id === item.id ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            style={{ transform: 'scaleY(0.75)', transformOrigin: 'top' }} // 👈 Shrinks height 25%
            onClick={disabled ? null : () => handleSelect(item)}
          />
        ))}
      </div>
    </div>
  );
});

export default ItemSelector;